import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section id="about" className="py-24 md:py-32 relative" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-15">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-16">
            <span className="text-rose-400 uppercase tracking-[0.2em] text-sm mb-4 block" data-id="element-17">
              Our Philosophy
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-lavender-50 mb-6" data-id="element-18">
              A Sacred Space <br data-id="element-19" />
              <span className="italic bg-gradient-to-r from-lavender-300 to-rose-400 bg-clip-text text-transparent" data-id="element-20">
                for the Senses
              </span>
            </h2>
            <div className="w-12 h-[2px] bg-gradient-to-r from-lavender-400 to-rose-400 mb-8" data-id="element-21"></div>
            <div className="space-y-6 text-lavender-100/75 font-light leading-relaxed text-lg" data-id="element-22">
              <p data-id="element-23">
                Tucked discreetly within Los Angeles, Afriel is a private
                sanctuary where the body becomes a sacred canvas. Our philosophy
                is rooted in the profound connection between touch, presence,
                and deep relaxation.
              </p>
              <p data-id="element-24">
                Every detail — from the warm lavender-scented air and the glow
                of candlelight to the meticulous cleanliness of our private
                suites — is curated to transport you. Here, your discretion is
                sacred, and your comfort is our highest art form.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-25">
            <div className="aspect-[4/5] overflow-hidden rounded-2xl relative shadow-2xl shadow-lavender-500/20" data-id="element-26">
              <img src="https://cdn.magicpatterns.com/uploads/n9AJ7avZPzCmAgxQKaWg3s/Day_Spa.jpg" alt="Afriel Spa — your host" className="object-cover w-full h-full" data-id="element-27" />
              <div className="absolute inset-0 bg-gradient-to-t from-plum-950/40 via-transparent to-transparent" data-id="element-28"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}